const STATUS_ATIVOS = ['CREATED', 'SENT', 'INDETERMINATE', 'REVERSAL_PENDING'];
const STATUS_RETENTAVEIS = ['REJECTED', 'ERROR'];

export function podeEstornarTransacaoConnectTef(transacao: any): boolean {
  return !!transacao && !!transacao.identificacao && transacao.operacao === 'PAYMENT' &&
    transacao.status === 'APPROVED' && transacao.statusFiscal !== 'AUTHORIZED' &&
    transacao.nfceAutorizada !== true;
}

export class PagamentoEletronicoFluxo {
  private transacoesPorPagamento: {[id: string]: any} = {};

  constructor(private pagamentos: any[] = [], private mapeamentos: any[] = []) {}

  listePagamentosEletronicos(): any[] {
    return (this.pagamentos || []).filter((pagamento: any) => !!this.obtenhaMapeamento(pagamento));
  }

  obtenhaTransacao(pagamento: any): any {
    return pagamento && this.transacoesPorPagamento[String(pagamento.id)] || null;
  }

  apliqueTransacao(idPagamento: number, transacao: any): void {
    if(!idPagamento || !transacao) return;
    this.transacoesPorPagamento[String(idPagamento)] = Object.assign(
      {}, this.transacoesPorPagamento[String(idPagamento)] || {}, transacao
    );
  }

  monteSolicitacao(terminal: any, pagamento: any): any {
    if(!terminal || !Number(terminal.id)) throw Error('Selecione um terminal ConnectTEF');
    const mapeamento = this.obtenhaMapeamento(pagamento);
    if(!mapeamento) throw Error('A forma de pagamento não está mapeada no ConnectTEF');

    return {
      terminalId: Number(terminal.id),
      tipoConnectTef: this.obtenhaTipoAVista(mapeamento),
      parcelas: 1,
      imprimirComprovante: true,
    };
  }

  podeTentarNovamente(pagamento: any): boolean {
    const transacao = this.obtenhaTransacao(pagamento);
    return !!transacao && STATUS_RETENTAVEIS.indexOf(String(transacao.status)) !== -1;
  }

  get podeFechar(): boolean {
    return !this.listePagamentosEletronicos().some((pagamento: any) => {
      const transacao = this.obtenhaTransacao(pagamento);
      return !!transacao && (
        STATUS_ATIVOS.indexOf(String(transacao.status)) !== -1 ||
        (transacao.status === 'APPROVED' && !this.transacaoConcluida(transacao))
      );
    });
  }

  get concluido(): boolean {
    const pagamentos = this.listePagamentosEletronicos();
    return pagamentos.length > 0 && pagamentos.every((pagamento: any) => {
      const transacao = this.obtenhaTransacao(pagamento);
      return this.transacaoConcluida(transacao);
    });
  }

  private transacaoConcluida(transacao: any): boolean {
    if(!transacao || transacao.status !== 'APPROVED') return false;
    if(transacao.posProcessamentoPendente === true) return false;
    if(['READY', 'GENERATED', 'AUTHORIZED', 'FISCAL_ERROR', 'BLOCKED_ACQUIRER_MAPPING']
      .indexOf(transacao.statusFiscal) !== -1) return true;
    return transacao.posProcessamentoPendente !== true && !!transacao.finalizadoEm;
  }

  private obtenhaMapeamento(pagamento: any): any {
    const idForma = Number(pagamento && pagamento.formaDePagamento && pagamento.formaDePagamento.id);
    return (this.mapeamentos || []).find((mapeamento: any) =>
      mapeamento && mapeamento.ativo !== false &&
      Number(mapeamento.formaDePagamento && mapeamento.formaDePagamento.id) === idForma
    );
  }

  private obtenhaTipoAVista(mapeamento: any): number {
    const tipos = (Array.isArray(mapeamento.tiposConnectTef) ? mapeamento.tiposConnectTef :
      String(mapeamento.tiposConnectTef || '').split(','))
      .map((tipo: any) => Number(tipo));
    const tipoPorMetodo: {[metodo: string]: number} = {
      CREDITO: 10,
      DEBITO: 20,
      PIX: 30,
      VOUCHER: 60,
      OUTRO: 99,
    };
    const tipo = tipoPorMetodo[String(mapeamento.metodo || '').toUpperCase()];
    if(!tipo || tipos.indexOf(tipo) === -1)
      throw Error('A forma de pagamento não possui uma modalidade à vista configurada no ConnectTEF');
    return tipo;
  }
}
